// 包含 title 、content 的 section
<template>
  <section class="c-section app-bg">
    <div v-if="title" class="section-header">
      <h2>{{ title }}</h2>
    </div>
    <div class="section-body">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.c-section {
  .section-header {
    padding: 20px 40px;
    background-color: #f9f9f9;
    border: 1px solid #e1e1e1;
  }
  .section-body{
    padding: 40px 50px;
  }
}
</style>

